import { lazy, Suspense } from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import BottomBlur from './components/BottomBlur.jsx'
import Header from './components/Header.jsx'
import AudioToggle from './components/AudioToggle.jsx'
import NotFound from './pages/NotFound.jsx'

const Home = lazy(() => import('./pages/Home.jsx'))
const About = lazy(() => import('./pages/About.jsx'))
const Philosophy = lazy(() => import('./pages/Philosophy.jsx'))
const Work = lazy(() => import('./pages/Work.jsx'))
const ServicesPage = lazy(() => import('./pages/Services.jsx'))
const Contact = lazy(() => import('./pages/Contact.jsx'))

function RouteFallback() {
  return <div className="min-h-screen bg-[#020b1f]" aria-hidden="true" />
}

function SiteShell() {
  return (
    <div className="relative min-h-screen w-full bg-black text-white">
      <BottomBlur />
      <Header />
      <AudioToggle />
      <main className="relative z-10 flex flex-col">
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  )
}

function App() {
  return (
    <Routes>
      <Route element={<SiteShell />}>
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="work" element={<Work />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="philosophy" element={<Philosophy />} />
        <Route path="contact" element={<Contact />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
